<template>
    <div id="leaderboardOverlay" class="overlay">
      <div id="leaderboardModal" class="modal large-modal bordered-modal" v-click-outside="toggleLeaderboardModal">
        <div class="modal-header">
          <div id="leaderboardHeader">LEADERBOARD</div>
        </div>
        <div id="leaderboardContent" class="modal-content transparent-bg">
          <div id="currentRankings">
            <div class="table-row header ranking-header">
              <div class="table-col sm">RANK</div>
              <div class="table-col lg">NAME</div>
              <div class="table-col" v-if="showLeaderboardRegions">REGION</div>
              <div class="table-col">TOTAL POINTS</div>
              <div class="table-col">ROUNDS COMPLETED</div>
            </div>
            <div class="table-row leaderboard-entry" :class="{'current-user-entry': (currentUser && (user.id === currentUser.id))}" v-for="(user, userIndex) in rankedUsers" :key="`user-${userIndex}`" :id="`rank${(userIndex + 1)}`">
              <div class="table-col sm entry-rank">{{ user.isTied ? '' : user.curRank }}</div>
              <div class="table-col lg entry-name">{{`${user.firstName} ${user.lastName}`}}</div>
              <div class="table-col entry-region" v-if="showLeaderboardRegions">{{ user.region }}</div>
              <div class="table-col entry-score">{{ user.score }}</div>
              <div class="table-col entry-rounds-completed">
                <div class="round-circle" :class="{'completed-round': completedRound(user, round.id)}" v-for="(round, roundIndex) in rounds" :key="`user-${userIndex}-round-${roundIndex}`">
                  <div class="round-number">{{ roundIndex + 1 }}</div>
                  <div class="round-completed" v-if="completedRound(user, round.id)">✓</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LeaderboardModal',
  components: {

  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'users',
      'rounds',
      'currentUser',
      'showLeaderboardRegions',
      'leaderboardMaxLength',
    ]),
    rankedUsers(){
      const theLeaderboardModal = this;

      let rankedUsers = [...theLeaderboardModal.users];

      rankedUsers.sort((userA, userB) => {
        // first sort by score
        if(userA.score < userB.score){
          return 1;
        }
        if(userA.score > userB.score){
          return -1;
        }
        // then sort by last name if there's a tie
        const nameA = userA.lastName.toLowerCase();
        const nameB = userB.lastName.toLowerCase();
        if(nameA < nameB){
          return -1;
        }
        if(nameA > nameB){
          return 1;
        }
        return 0;
      });
      // set up ranking numbers with pseudo golf leaderboard display
      let curRank = 1;
      let isTied = false;
      rankedUsers.forEach((rankedUser, rankedUserIndex) => {
        isTied = false;
        if(rankedUserIndex > 0){
          if(rankedUser.score < rankedUsers[(rankedUserIndex - 1)].score){
            curRank++;
          }else{
            isTied = true;
          }
        }
        rankedUsers[rankedUserIndex].curRank = curRank;
        rankedUsers[rankedUserIndex].isTied = isTied;
      })

      return rankedUsers.slice(0, theLeaderboardModal.leaderboardMaxLength);
    },
  },
  methods: {
    ...mapActions([
      'toggleLeaderboardModal'
    ]),
    completedRound(user, roundID){
      let completedRound = true;
      let roundQuestionIDs = user.questions.filter(question => question.roundID === roundID).map(question => question.masterQuestionID)
      roundQuestionIDs.forEach(questionID => {
        if(!user.completedQuestions.includes(questionID)){
          completedRound = false;
        }
      })

      return completedRound;
    }
  },
  mounted(){

  },
  beforeUnmount(){

  },
  data: function(){
    return {

    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<style scoped>
  #leaderboardOverlay{

  }

  #leaderboardModal{

  }

  #leaderboardHeader{
/*    font-family: 'LuckiestGuy';*/
/*    font-size: 40px;*/
  }

  #leaderboardContent{
/*    font-family: 'LuckiestGuy';*/
    padding: 0px;
  }


  #currentRankings {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
/*    color: white;*/
  }

  .table-row{
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    width: 100%;
    font-weight: bold;
  }
  .table-row.header{
/*    border: none;*/
    position: sticky;
    top: 0;
    min-height: 30px;
    z-index: 50;
  }

  .table-col{
    flex: 2;
    padding: 5px;
/*    word-break: break-all;*/
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .table-col.sm{
    flex: 1;
  }
  .table-col.lg{
    flex: 3;
  }

  .entry-rounds-completed{
    display: flex;
    flex-direction: row;
/*    justify-content: space-evenly;*/
  }

  .round-circle{
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    margin: 0px 5px;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .round-number{
    position: absolute;
    z-index: 1;
    font-size: 32px;
  }

  .round-completed{
    position: absolute;
    z-index: 2;
    font-size: 24px;
  }



  @media screen and (max-width: 615px){
    .leaderboard-entry{
      font-size: 16px;
    }
    .table-row.header .table-col{
      font-size: 14px;
      line-height: 1em;
    }
    #currentRankings{
/*      height: 264px;*/
/*      height: 364px;*/
    }
    .entry-rank{
      padding-left: 10px;
    }
    .entry-score{
      padding-right: 10px;
    }
  }

  @media screen and (max-width: 542px){
    .leaderboard-entry{
      font-size: 16px;
    }
    #currentRankings{
/*      height: 244px;*/
    }
  }
</style>